import classNames from 'classnames';
import * as React from 'react';
const Select = (props) => {
    const { children, className, onChange, optimisticUpdate = false, value = '', ...rest } = props;
    return (React.createElement("select", { ...rest, className: classNames(className, 'ixu-select'), defaultChecked: optimisticUpdate ? !!value : undefined, onChange: event => onChange?.(event.target.value), value: !optimisticUpdate ? value : undefined }, children));
};
export default Select;
//# sourceMappingURL=Select.js.map